__turbopack_context__.v({
  "bare": "tick-module__I6zm6a__bare",
  "box": "tick-module__I6zm6a__box",
  "content": "tick-module__I6zm6a__content",
  "inner": "tick-module__I6zm6a__inner",
  "tick": "tick-module__I6zm6a__tick",
});
